import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
// Removed Redux auth selectors - now using useAuth() hook
import { useAuth } from '../context/AuthContext';
import { useFacilityChangeListener } from './useFacilityChangeListener';
import { RoutePath } from '../types/enums';

/**
 * Custom hook to handle redirects when user changes default facility
 * while on patient details or encounter details pages
 */
export const useFacilityRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const previousFacilityRef = useRef(user?.defaultFacility);

  // Check if current path is a patient details or encounter details page
  const getRedirectPath = () => {
    const path = location.pathname;
    // Patient details page: /patients/:id
    if (/^\/patients\/[^/]+$/.test(path)) {
      return RoutePath.PATIENTS;
    }
    // Encounter details page: /patients/:patientId/encounters/:encounterId or /encounters/:encounterId
    if (/^\/patients\/[^/]+\/encounters\/[^/]+$/.test(path) || /^\/encounters\/[^/]+$/.test(path)) {
      return RoutePath.ENCOUNTERS;
    }
    return null;
  };

  // Handle facility change
  const handleFacilityChange = (newFacilityId, previousFacilityId) => {
    const redirectPath = getRedirectPath();
    if (!redirectPath) return;
    if (newFacilityId === previousFacilityId) return;
    console.log('useFacilityRedirect: Facility changed, redirecting to', redirectPath);
    navigate(redirectPath, { replace: true });
  };

  // Listen for facility changes
  useFacilityChangeListener(handleFacilityChange);

  // Update the previous facility reference when user changes
  useEffect(() => {
    previousFacilityRef.current = user?.defaultFacility;
  }, [user?.defaultFacility]);
}; 